/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_login_callback__failure = /** @type {(inputs: {}) => string} */ () => {
	return `Bei der Anmeldung ist ein Fehler aufgetreten`
};

const en_login_callback__failure = /** @type {(inputs: {}) => string} */ () => {
	return `Login failed`
};

const es_login_callback__failure = /** @type {(inputs: {}) => string} */ () => {
	return `No se pudo iniciar sesión`
};

const fr_login_callback__failure = /** @type {(inputs: {}) => string} */ () => {
	return `Échec lors de la connexion`
};

const it_login_callback__failure = /** @type {(inputs: {}) => string} */ () => {
	return `Connessione non riuscita`
};

const nl_login_callback__failure = /** @type {(inputs: {}) => string} */ () => {
	return `Aanmeldingsfout`
};

const pt_login_callback__failure = /** @type {(inputs: {}) => string} */ () => {
	return `Falha na ligação`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__failure = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_callback__failure(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_callback__failure", locale)
	if (locale === "de") return de_login_callback__failure(inputs)
	if (locale === "en") return en_login_callback__failure(inputs)
	if (locale === "es") return es_login_callback__failure(inputs)
	if (locale === "fr") return fr_login_callback__failure(inputs)
	if (locale === "it") return it_login_callback__failure(inputs)
	if (locale === "nl") return nl_login_callback__failure(inputs)
	return pt_login_callback__failure(inputs)
};